import {
  breakpoints,
  colorMap,
  colors,
  font,
  shape,
  spacing,
  typography
} from './Tokens';
import { createWebTheme } from './functions';

export default createWebTheme({
  font,
  colors,
  colorMap,
  spacing,
  shape,
  typography,
  breakpoints
});
